import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {WebNavigationService} from '../../navigation.service';
import Popper from 'popper.js';

declare var $;

@Component({
  selector: 'app-usuarios-option',
  templateUrl: './usuarios-option.component.html',
  styleUrls: ['./usuarios-option.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UsuariosOptionComponent implements OnInit {
  private popper;
  private timer;
  private anotherPopper;

  constructor(private navigationService: WebNavigationService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    const reference = $('#usuarios-btn');
    this.popper = $('#tree-users-options-collapsed');
    this.anotherPopper = new Popper(
      reference,
      this.popper,
      {
        placement: 'right'
      }
    );
    $('#usuarios-btn, #tree-users-options-collapsed').hover(() => {
      if (!this.navigationService.expanded) {
        clearTimeout(this.timer);
        this.anotherPopper.update();
        this.popper.addClass('display');
      }
    }, () => {
      this.timer = setTimeout(() => {
        if (!this.navigationService.expanded) {
          this.popper.removeClass('display');
        }
      }, 200);
    });

  }

  get selectedOption() {
    return this.navigationService.selectedOption;
  }

  get expanded() {
    return this.navigationService.expanded;
  }

  get expandPayments() {
    return this.navigationService.expandUsers;
  }

  selectOption(option) {
    this.navigationService.selectOption(option);
  }

  selectPaymentsOption(conciliacionOption) {
    this.navigationService.selectConciliacionOption(conciliacionOption);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/options/usuarios/usuarios-option.component.ts